import { render } from "./create-payout.vue?vue&type=template&id=4164a23a&scoped=true"
import script from "./create-payout.vue?vue&type=script&lang=js"
export * from "./create-payout.vue?vue&type=script&lang=js"

import "./create-payout.vue?vue&type=style&index=0&id=4164a23a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4164a23a"]])

export default __exports__